import React, { ReactElement, useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";

import IconMoreVert from "@material-ui/icons/MoreVert";

type Item = {
  icon: ReactElement;
  text: string;
  onClick?: () => void;
  disabled?: boolean;
};

export function MenuComponent({
  translationPath,
  items,
  t
}: {
  translationPath: string;
  items: Item[];
} & WithTranslation) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  function handleClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function close(onClick?: () => void) {
    setAnchorEl(null);

    if (onClick) {
      onClick();
    }
  }

  return (
    <div>
      <Button onClick={handleClick}>
        <IconMoreVert />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {items.map(({ onClick, icon: Icon, text, ...props }) => (
          <MenuItem key={text} onClick={() => close(onClick)} {...props}>
            {Icon}
            <ListItemText primary={t(`${translationPath}.${text}`)} />
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default withTranslation()(MenuComponent);
